import { ComponentChildren } from 'preact';
import { useTranslation } from '../../../../utils/useTranslation';
import { IconButton } from '../../components/IconButton/IconButton';
import { Typography } from '../../components/Typography/Typography';
import { useCurrentAsset } from '../../hooks/CurrentAssetProvider';
import { usePlayer } from '../../hooks/PlayerProvider';
import { useIcons } from '../../hooks/useIcons';
import ns from '../../translations';
import { AudioNativePlayButton } from '../../components/AudioNativePlayButton/AudioNativePlayButton';
import { getNativeAudioLink } from '../../utils/nativeAudioLink';
import { useProvider } from '../../hooks/useProvider';

interface TtsIdleLayoutProps {
  infoButton: ComponentChildren;
  infoFooter: ComponentChildren;
}

export const TtsIdleLayout = ({
  infoButton,
  infoFooter,
}: TtsIdleLayoutProps) => {
  const { Play, Ai } = useIcons();
  const { t } = useTranslation(ns);
  const player = usePlayer();
  const { asset } = useCurrentAsset();
  const { configProvider } = useProvider();
  const nativeAudioLink = getNativeAudioLink(asset, configProvider);

  const durationInMinutes =
    asset?.duration && asset.duration > 0
      ? Math.ceil(asset.duration / 1000 / 60)
      : null;

  return (
    <div className="vgp-tts-layout-idle">
      <div className="vgp-tts-layout-idle-container">
        <div className="vgp-tts-layout-idle-left">
          <AudioNativePlayButton
            onClick={() => {
              player.setMute(false);
              player.play();
            }}
            size="medium"
            href={nativeAudioLink}
            className="vgp-tts-layout-idle-play-button"
          >
            <Play />
          </AudioNativePlayButton>
          <div className="vgp-tts-layout-idle-text">
            <div className="vgp-tts-layout-idle-title">
              <Typography variant="label" size="medium" bold color="primary">
                {t('Listen to the article')}
              </Typography>
              <Ai className="vgp-tts-layout-idle-ai-icon" />
            </div>
            {durationInMinutes !== null && (
              <Typography variant="label" size="small" color="primary">
                {durationInMinutes} {t('min')}
              </Typography>
            )}
          </div>
        </div>
        {infoButton}
      </div>
      {infoFooter}
    </div>
  );
};
